import React, { useCallback, useContext } from 'react';
import update from 'immutability-helper';
import Card from './Card';
import { useFormik } from "formik";
import { Button, Form } from "components";
import { makeStyles } from "@material-ui/core/styles";
import { DialogContext } from "contexts";

const useStyles = makeStyles((theme) => ({
  addValueControl: {
    display: 'flex',
    marginBottom: '8px'
  },
  valueTextInput: {
    margin: '0 8px 0 0',
    width: '100%'
  }
}));

const style = {
  width: 400,
};

export default (props) => {
  const { cards, setCards, isValueUsed } = props;

  const { actions: dialogActions } = useContext(DialogContext);

  const classes = useStyles();

  const moveCard = useCallback((dragIndex, hoverIndex) => {
    const dragCard = cards[dragIndex];
    setCards(update(cards, {
      $splice: [
        [dragIndex, 1],
        [hoverIndex, 0, dragCard],
      ],
    }).map((c, i) => ({ ...c, index: i })));
  }, [cards, setCards]);

  const deleteCard = useCallback((index) => {
    if (isValueUsed(cards[index]?.name)) {
      dialogActions.open({
        title: 'Delete Value',
        contentText: 'You cannot delete value that is used.',
        acceptBtnText: 'OK'
      });
      return;
    }
    setCards(update(cards, {
      $splice: [[index, 1]]
    }).map((c, i) => ({ ...c, index: i })));
  }, [cards, setCards, dialogActions, isValueUsed]);

  const renderCard = (card, index) => {
    return (
      <Card
        key={card.name}
        index={index}
        id={card.name}
        text={card.name}
        moveCard={moveCard}
        deleteCard={deleteCard}
      />
    );
  };

  const formik = useFormik({
    initialValues: {
      valueText: '',
    },
    onSubmit: values => {
      const value = { name: values.valueText.trim() };
      setCards(update(cards, {
        $unshift: [value]
      }).map((c, i) => ({ ...c, index: i })));
      formik.handleChange({ target: { name: 'valueText', value: '' } });
    },
    validate: (values) => {
      if (!isNewValueUnique(values))
        return { valueText: true, valueTextErr: 'Text should be unique' };
    }
  });

  const isNewValueUnique = (values) => {
    return !cards.find(c => c.name === values.valueText.trim());
  };

  return (
    <>
      <form onSubmit={formik.handleSubmit} className={classes.addValueControl}>
        <Form.TextField
          error={formik.errors.valueText}
          variant="outlined"
          margin="normal"
          id="valueText"
          label={
            formik.errors.valueText
              ? formik.errors.valueTextErr
              : "Value Text"
          }
          name="valueText"
          size="small"
          className={classes.valueTextInput}
          onChange={formik.handleChange}
          value={formik.values.valueText}
        />
        <Button
          variant="outlined"
          color="primary"
          type="submit"
          disabled={
            !formik.values.valueText.trim() || !isNewValueUnique(formik.values)
          }
        >
          Add
        </Button>
      </form>
      <div style={style}>{cards.map((card, i) => renderCard(card, i))}</div>
    </>
  );
};